module.exports = __webpack_public_path__ + "assets/svg/Icons/32/link-gray-8bd74f.svg";